export const ISSUING_COMPANY_COVERED_STATES = [
  {
    id: 'aigPropertyCasualtyCompany',
    name: 'AIG Property Casualty Company',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'commerceAndIndustryInsuranceCompany',
    name: 'Commerce and Industry',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'graniteStateInsuranceCompany',
    name: 'Granite State',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'theInsuranceCompanyOfTheStateOfPennsylvania',
    name: 'Ins. Co. of the State of Pennsylvania',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'HI',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'nationalUnionFireInsuranceCompanyOfPittsburghPa',
    name: 'National Union Fire Insurance Company of Pittsburgh, PA',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'HI',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'americanHomeAssuranceCompany',
    name: 'AMERICAN HOME ASSURANCE COMPANY',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'HI',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'newHampshireInsuranceCompany',
    name: 'NEW HAMPSHIRE INSURANCE CO',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'HI',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'aigAssuranceCompany',
    name: 'AIG ASSURANCE COMPANY',
    coveredStates: [
      'AK',
      'AR',
      'AZ',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MD',
      'MI',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NM',
      'NV',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
  {
    id: 'aiuInsuranceCompany',
    name: 'AIU INSURANCE COMPANY',
    coveredStates: [
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NC',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VA',
      'VT',
      'WA',
      'WI',
      'WV',
    ],
  },
  {
    id: 'illinoisNationalInsuranceCompany',
    name: 'ILLINOIS NATIONAL INSURANCE CO',
    coveredStates: [
      'AK',
      'AL',
      'AZ',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'HI',
      'IA',
      'ID',
      'IL',
      'IN',
      'KS',
      'KY',
      'LA',
      'MA',
      'MD',
      'ME',
      'MI',
      'MN',
      'MO',
      'MT',
      'ND',
      'NE',
      'NH',
      'NJ',
      'NM',
      'NV',
      'NY',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'WA',
      'WI',
      'WV',
      'WY',
    ],
  },
];
export const DEFAULT_OPERATIONS_EMAIL = 'ui-uim-pip@aig.com';
export const ADD_POLICY_ALL_COVERED_STATES = [
  {
    value: 'AK',
    name: 'Alaska',
  },
  {
    value: 'AL',
    name: 'Alabama',
  },
  {
    value: 'AR',
    name: 'Arkansas',
  },
  {
    value: 'AZ',
    name: 'Arizona',
  },
  {
    value: 'CA',
    name: 'California',
  },
  {
    value: 'CO',
    name: 'Colorado',
  },
  {
    value: 'CT',
    name: 'Connecticut',
  },
  {
    value: 'DC',
    name: 'District of Columbia',
  },
  {
    value: 'DE',
    name: 'Delaware',
  },
  {
    value: 'FL',
    name: 'Florida',
  },
  {
    value: 'GA',
    name: 'Georgia',
  },
  {
    value: 'HI',
    name: 'Hawaii',
  },
  {
    value: 'IA',
    name: 'Iowa',
  },
  {
    value: 'ID',
    name: 'Idaho',
  },
  {
    value: 'IL',
    name: 'Illinois',
  },
  {
    value: 'IN',
    name: 'Indiana',
  },
  {
    value: 'KS',
    name: 'Kansas',
  },
  {
    value: 'KY',
    name: 'Kentucky',
  },
  {
    value: 'LA',
    name: 'Louisiana',
  },
  {
    value: 'MA',
    name: 'Massachusetts',
  },
  {
    value: 'MD',
    name: 'Maryland',
  },
  {
    value: 'ME',
    name: 'Maine',
  },
  {
    value: 'MI',
    name: 'Michigan',
  },
  {
    value: 'MN',
    name: 'Minnesota',
  },
  {
    value: 'MO',
    name: 'Missouri',
  },
  {
    value: 'MS',
    name: 'Mississippi',
  },
  {
    value: 'MT',
    name: 'Montana',
  },
  {
    value: 'NC',
    name: 'North Carolina',
  },
  {
    value: 'ND',
    name: 'North Dakota',
  },
  {
    value: 'NE',
    name: 'Nebraska',
  },
  {
    value: 'NH',
    name: 'New Hampshire',
  },
  {
    value: 'NJ',
    name: 'New Jersey',
  },
  {
    value: 'NM',
    name: 'New Mexico',
  },
  {
    value: 'NV',
    name: 'Nevada',
  },
  {
    value: 'NY',
    name: 'New York',
  },
  {
    value: 'OH',
    name: 'Ohio',
  },
  {
    value: 'OK',
    name: 'Oklahoma',
  },
  {
    value: 'OR',
    name: 'Oregon',
  },
  {
    value: 'PA',
    name: 'Pennsylvania',
  },
  {
    value: 'RI',
    name: 'Rhode Island',
  },
  {
    value: 'SC',
    name: 'South Carolina',
  },
  {
    value: 'SD',
    name: 'South Dakota',
  },
  {
    value: 'TN',
    name: 'Tennessee',
  },
  {
    value: 'TX',
    name: 'Texas',
  },
  {
    value: 'UT',
    name: 'Utah',
  },
  {
    value: 'VA',
    name: 'Virginia',
  },
  {
    value: 'VT',
    name: 'Vermont',
  },
  {
    value: 'WA',
    name: 'Washington',
  },
  {
    value: 'WI',
    name: 'Wisconsin',
  },
  {
    value: 'WV',
    name: 'West Virginia',
  },
  {
    value: 'WY',
    name: 'Wyoming',
  },
];

export const REGION_LIST = [
  { id: 'NEWYORK', name: 'NEW YORK' },
  { id: 'CHICAGO', name: 'CHICAGO' },
  { id: 'SANFRANCISCO', name: 'SAN FRANCISCO' },
  { id: 'BOSTON', name: 'BOSTON' },
  { id: 'LOSANGELES', name: 'LOS ANGELES' },
  { id: 'ATLANTA', name: 'ATLANTA' },
  { id: 'HOUSTON', name: 'HOUSTON' },
  { id: 'DALLAS', name: 'DALLAS' },
  { id: 'CLEVELAND', name: 'CLEVELAND' },
  { id: 'TORONTO', name: 'TORONTO' },
  { id: 'PHILADELPHIA', name: 'PHILADELPHIA' },
  { id: 'LONDONEXLEXRUNOFF', name: 'LONDON EX LEX - RUNOFF' },
  { id: 'PITTSBURGH', name: 'PITTSBURGH' },
  { id: 'NEWENGLANDRISKRUNOFF', name: 'NEW ENGLAND RISK - RUNOFF' },
  { id: 'LONDONRUNOFF', name: 'LONDON - RUNOFF' },
  { id: 'NORTHEASTERNRUNOFF', name: 'NORTH EASTERN - RUNOFF' },
  { id: 'RISK_SPEC_RUNOFF', name: 'RISK SPEC - RUNOFF' },
  { id: 'INTERNL_RUNOFF', name: 'INTERNL - RUNOFF' },
  { id: 'NATIONAL_BRANCH', name: 'NATIONAL BRANCH' },
  { id: 'NATIONAL', name: 'NATIONAL' },
  { id: 'CANADIAN_HO_RUNOFF', name: 'CANADIAN HO - RUNOFF' },
  { id: 'GLOBAL', name: 'GLOBAL' },
];

export const DIVISION_LIST = [
  { id: 'CASUALTY_DOMESTIC', name: 'Casualty Domestic' },
  { id: 'GLOBAL_ENERGY_MIDDLE_MARKET', name: 'Global Energy Middle Market' },
  { id: 'TRUCKING_INSURANCE_GROUP', name: 'Trucking Insurance Group' },
  { id: 'WORLDSOURCE_REVERSE_FLOW', name: 'WorldSource Reverse Flow' },
  { id: 'GROUP_CAPTIVES', name: 'Group Captives' },
  { id: 'ENTERPRISE_CASUALTY', name: 'Enterprise Casualty' },
  { id: 'PRIMARY_ENERGY', name: 'Primary Energy' },
  { id: 'PRIMARY_NATIONAL_ACCOUNTS', name: 'Primary National Accounts' },
  { id: 'PRIMARY_COMMERCIAL', name: 'Primary Commercial' },
  { id: 'PROGRAM', name: 'Program' },
  { id: 'ENVIRONMENTAL_CASUALTY', name: 'Environmental Casualty' },
  { id: 'PRIMARY_CONSTRUCTION', name: 'Primary Construction' },
  { id: 'AIGRM_TRANSPORTATION', name: 'AIGRM Transportation' },
  { id: 'OTHER', name: 'Other' },
];

export interface AdobeDataLayer {
  event: string;
  site: {
    code: string;
    country: string;
    language: string;
    platform: string;
    lob: string;
    businessSegment: string;
    environment: string;
  };
  user: {
    userType: string;
    userId: string;
  };
  page: {
    pageName: string;
    URL: string;
    fullURL: string;
    previousURL: string;
  };
  form: {
    formType: string;
    step: string;
  };
  umuim: {
    bodilyInjury: string;
    limits: string;
    stackedOptions: string;
    coverages: string;
  };
  pip: {
    pipType: string;
    pipAdditional: string;
    pipAcceptance: string;
    pipCoverage: string;
  };
}

export interface AdobeDataLayerCta {
  event: string;
  site: {
    code: string;
    country: string;
    language: string;
    platform: string;
    lob: string;
    businessSegment: string;
    environment: string;
  };
  page: {
    pageName: string;
    URL: string;
    fullURL: string;
    previousURL: string;
  };
  user: {
    userType: string;
    userId: string;
  };
  cta: {
    ctaType: string;
    ctaName: string;
    ctaURL: string;
  };
}

export interface AdobeDataLayerDownload {
  event: string;
  site: {
    code: string;
    country: string;
    language: string;
    platform: string;
    lob: string;
    businessSegment: string;
    environment: string;
  };
  page: {
    pageName: string;
    URL: string;
    fullURL: string;
    previousURL: string;
  };
  user: {
    userType: string;
    userId: string;
  };
  download: {
    fileName: string;
    fileType: string;
    fileURL: string;
    fileFormat: string;
  };
}
